// extracted by mini-css-extract-plugin
module.exports = {"PlaceLink":"PlaceLink_PlaceLink__PoX-O","Shadow":"PlaceLink_Shadow__39Tdw"};